// components/Navbar.js
import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="logo" onClick={() => scrollToSection('home')}>
          <div className="logo-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M10 10 L20 5 L30 10 L30 20 L20 35 L10 20 Z" fill="url(#gradient)" />
              <path d="M15 15 L25 15 L25 25 L15 25 Z" fill="#fff" opacity="0.9" />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#00ffff" />
                  <stop offset="100%" stopColor="#764ba2" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="logo-text-container">
            <div className="logo-text">LEADVALA</div>
            <div className="logo-tagline">Lead The Way</div>
          </div>
        </div>

        <div className="nav-links">
          <button onClick={() => scrollToSection('home')} className="nav-link">Home</button>
          <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
          <button onClick={() => scrollToSection('how-it-works')} className="nav-link">How It Works</button>
          <button onClick={() => scrollToSection('pricing')} className="nav-link">Pricing</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
          <button className="cta-button">Get Free Report</button>
        </div>

        <div className="mobile-menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <span className="menu-bar"></span>
          <span className="menu-bar"></span>
          <span className="menu-bar"></span>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('home')} className="mobile-nav-link">Home</button>
          <button onClick={() => scrollToSection('about')} className="mobile-nav-link">About</button>
          <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Services</button>
          <button onClick={() => scrollToSection('how-it-works')} className="mobile-nav-link">How It Works</button>
          <button onClick={() => scrollToSection('pricing')} className="mobile-nav-link">Pricing</button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
          <button className="mobile-cta-button">Get Free Report</button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;